var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',_vm._l((_vm.tradingHistory),function(history,index){return _c('TradingHistoryTableItems',{key:index,attrs:{"history":history}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }